import React from 'react';
import { projects } from '../data/projects';
import { Link } from 'react-router-dom';
import { useSound } from '../hooks/useSound';

const Archive: React.FC = () => {
  const { playClick } = useSound();

  return (
    <main className="min-h-screen w-full bg-gray-50 text-black">
      <div className="container mx-auto px-4 pt-32 pb-20">
        <h1 className="text-5xl lg:text-6xl font-normal text-black tracking-tighter mb-2">
          Archive
        </h1>
        <p className="text-2xl lg:text-3xl font-normal text-gray-500 tracking-tight mb-12">
          Some goodies from our past
        </p>

        <div className="flex flex-col gap-4">
          {projects.map((project) => (
            <Link
              to={project.slug}
              key={project.id}
              onClick={playClick}
              className="bg-white rounded-3xl p-6 lg:p-8 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 lg:gap-0 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex flex-col">
                <div className="flex items-center gap-3">
                  <h2 className="text-2xl lg:text-3xl font-normal text-black tracking-tighter group-hover:text-gray-600 transition-colors">
                    {project.title}
                  </h2>
                  {/* Optional Arrow icon on hover could go here */}
                </div>
                <p className="text-lg lg:text-xl font-normal text-gray-500 tracking-tight mt-1">
                  {project.location}
                </p>

                <div className="flex gap-3 mt-4">
                  <span className="px-4 py-1.5 rounded-full bg-gray-100 text-gray-600 text-base font-normal">
                    2025
                  </span>
                  <span className="px-4 py-1.5 rounded-full bg-gray-100 text-gray-600 text-base font-normal">
                    {project.category.text}
                  </span>
                </div>
              </div>
              <div className="w-full lg:w-1/3 h-40 lg:h-48 overflow-hidden rounded-2xl">
                {project.mediaType === 'video' ? (
                  <video
                    src={project.thumbnailSrc}
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={project.mediaStyle}
                    className="w-full h-full object-cover transform transition duration-500 group-hover:scale-105"
                  />
                ) : (
                  <img
                    src={project.thumbnailSrc}
                    alt={project.title}
                    style={project.mediaStyle}
                    className="w-full h-full object-cover transform transition duration-500 group-hover:scale-105"
                  />
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Archive;